import type { MeResponse } from '../api/protocol';
import { navigate } from '../router';
import { Avatar } from './Avatar';
import { Icon, type IconName } from './Icon';
import { BRAND, Logo } from './Logo';

export type RailTarget = 'voice' | 'settings';

function RailButton({ icon, label, active, onClick, testId, badge }: { icon: IconName; label: string; active?: boolean; onClick: () => void; testId?: string; badge?: boolean }) {
  return (
    <button type="button" className={`rail-btn${active ? ' is-active' : ''}`} onClick={onClick} aria-label={label} title={label} aria-current={active ? 'page' : undefined} data-testid={testId}>
      <Icon name={icon} size={20} />
      {badge ? <span className="rail-badge" aria-hidden /> : null}
      <span className="rail-label">{label}</span>
    </button>
  );
}

/** Narrow vertical icon bar (bottom bar on mobile): Titanet mark, Voce, Impostazioni, your head. */
export function Rail({ me, active, live }: { me: MeResponse; active: RailTarget; live: boolean }) {
  return (
    <nav className="rail glass" aria-label="Navigazione">
      <a
        className="rail-logo"
        href="/"
        onClick={(e) => {
          e.preventDefault();
          navigate('/');
        }}
        title={`${BRAND.product} · ${BRAND.domain}`}
        aria-label={`${BRAND.product}, pagina voce`}
      >
        <Logo variant="mark" size={44} />
      </a>
      <div className="rail-main">
        <RailButton icon="headphones" label="Voce" active={active === 'voice'} badge={live} onClick={() => navigate('/')} testId="nav-voice" />
        <RailButton icon="gear" label="Impostazioni" active={active === 'settings'} onClick={() => navigate('/settings')} testId="nav-settings" />
      </div>
      <button type="button" className="rail-me" onClick={() => navigate('/settings#account')} aria-label={`Account: ${me.name}`} title={me.name}>
        <Avatar uuid={me.uuid} name={me.name} size={36} />
      </button>
    </nav>
  );
}
